function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import saveAs from 'file-saver';
import { mapState } from 'vuex';
export default {
  props: {
    mimeType: {
      type: String,
      "default": 'text/csv'
    }
  },
  data: function data() {
    return {
      downloadState: 'completed'
    };
  },
  computed: _objectSpread({}, mapState({
    currentResultType: function currentResultType(s) {
      return s.api.resultType;
    },
    queryExecutionState: function queryExecutionState(s) {
      return s.api.executionState;
    }
  }), {
    disabled: function disabled() {
      return this.downloadState !== 'completed' || this.queryExecutionState !== 'completed';
    },
    label: function label() {
      return this.$t('download');
    }
  }),
  methods: {
    downloadAction: function downloadAction(action, filename, page_view_name) {
      var _this = this;

      this.downloadState = 'running';
      this.$store.dispatch(action, {
        mimeType: this.mimeType
      })["catch"](function (e) {
        _this.downloadState = 'error';
        return Promise.reject(e);
      }).then(function (blob) {
        _this.downloadState = 'completed';
        saveAs(blob, filename);

        _this.$ga.page("/search/".concat(_this.currentResultType, "/").concat(page_view_name));
      });
    }
  }
};